/** Protección para respuestas antiguas que ya guardaron el resumen interno. */
export function visibleAnswerText(text: string): string {
  return text.split("\n").filter((line) => !/\[UI\]|bloques\s+emitidos\s*:/i.test(line)).join("\n").trim();
}
